import { css, cx } from "@linaria/core";

import { getDefaultHeight, SVG } from "./utils";
import { easings } from "../css-tokens/easings";

type Props = {
  color?: string;
  playOnly?: boolean;
} & React.SVGProps<SVGSVGElement>;

const transitionCls = css`
  & > path.speechBubble {
    transition: opacity 0.125s linear;
  }

  & > path.play {
    transform-origin: 55% 45%;
    transition: transform 0.125s ${easings.inOutQuad},
      stroke-width 0.125s ${easings.inOutQuad};
  }

  &.playOnly {
    & > path.speechBubble {
      opacity: 0;
    }

    & > path.play {
      transform: scale(2.5);
      stroke-width: 0.72;
    }
  }
`;

export const ReadOutLoudIcon: React.FC<Props> = ({
  color = "currentColor",
  playOnly,
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 24)}
      {...svgProps}
      className={cx(svgProps.className, transitionCls, playOnly && "playOnly")}
      viewBox="0 0 25 25"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
    >
      <path
        className="speechBubble"
        d="M13.3.9C7.3.9 2.5 5.7 2.5 11.7c0 2 .6 4 1.6 5.7L.9 24.1l6.7-3.2c5.1 3.1 11.7 1.6 14.9-3.5 3.1-5.1 1.6-11.7-3.5-14.9C17.3 1.4 15.3.9 13.3.9z"
      />
      <path
        className="play"
        d="M11.4 15.3c-.4.2-1 0-1.2-.4h0c-.1-.1-.1-.3-.1-.4V8.6c0-.5.4-.9.9-.9h0c.1 0 .3 0 .4.1l5.9 3c.4.2.6.7.4 1.2-.1.2-.2.3-.4.4l-5.9 2.9z"
      />
    </SVG>
  );
};
